import React, { useState } from 'react';
import products from "../../data/product"
import artists from "../../data/artist"
import { useLocalization } from '../../utils/hooks/useLocalization'
import styles from './ProductsSection.module.css';

const ProductsSection = () => {
  
  const { t, currentLanguage } = useLocalization();

  const [hoveredProduct, setHoveredProduct] = useState(null);
  return (
    <section id="products" className={styles.products}>
      <div className={styles.container}>
        {/* Section Header */}
        <div className={styles.header}>
            <h2 className={styles.title}>
              <span className={styles.titleMain}>OUR</span>
              <span className={styles.titleAccent}>COLLECTION</span>
            </h2>
          <p className={styles.subtitle}>
            {t("landing_ProductsSubtitle")}
          </p>
        </div>

        {/* Products Grid */}
        <div className={styles.grid}>
          {products.items.map((product) => {
            const artist = artists.items.find((a) => a.id = product.artist_id);
            return (
              <a
                key={product.id}
                className={styles.card}
                onMouseEnter={() => setHoveredProduct(product.id)}
                onMouseLeave={() => setHoveredProduct(null)}
                  href={`/${currentLanguage}/product/${product.id}`}
              >
                {/* Large Image Area */}
                <div className={styles.imageContainer}>
                  <img src={require(`../../../images/${product.id_photos_preview}`)} alt={product.name} className={styles.image} />
                  
                  
                  {/* Category Badge */}
                  <div className={styles.categoryBadge}>
                    {artist.nickName}
                  </div>
                </div>

                {/* Compact Product Info */}
                <div className={styles.info}>
                  <h3 className={styles.productName}>{product.name}</h3>
                  <h6 className={styles.description}>{product.briefDescription[currentLanguage]}</h6>
                </div>

                
                {/* Category Badge */}
                {/* <div className={styles.footer}>
                  <div className={styles.price}>
                    {product.price}
                  </div>
                </div> */}
              </a>
            )
          })}
        </div>

        {/* Call to Action */}
        <div className={styles.ctaContainer}>
          <a className={styles.cta} href={`/${currentLanguage}/products`}>
            <button className={styles.ctaBtn}>
              {t("landing_viewCollection")}
            </button>
          </a>
        </div>
      </div>
    </section>
  );
};

export default ProductsSection;